import GenericCard from './generic-card';

export default GenericCard;
